import {SetStyle} from './set-style';
import {message} from '@common/i18n/message';

export interface ResizeProps {
  width: string;
  height: string;
  maxWidth?: string;
  maxHeight?: string;
}

export class ResizeNode extends SetStyle {
  displayName = message('Changed size');
  constructor(
    protected newProps: ResizeProps,
    el: HTMLElement,
  ) {
    super(newProps, el);
  }

  protected onBeforeExecute() {
    // Only force maxWidth/maxHeight removal if not explicitly specified by caller.
    // Manual drag resize passes no maxWidth → gets 'none' to allow free resizing.
    // Image updates pass maxWidth: '100%' → keeps containment within parent.
    if (this.newProps.maxWidth === undefined) {
      this.newProps.maxWidth = 'none';
    }
    if (this.newProps.maxHeight === undefined) {
      this.newProps.maxHeight = 'none';
    }
    super.onBeforeExecute();
  }
}
